module.exports = __webpack_public_path__ + "img/portrait-090.3c80fca6.jpg";